import Modal from 'LuxKit/Modal/Modal'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import SponsoredTileLogo from 'sponsoredSearch/SponsoredTileLogo'
import { sponsoredSearchTileLogo } from 'sponsoredSearch/sponsoredSearchTileMedia'

const LogoWrapper = styled.div`
  margin-block-start: ${rem(20)};

  ${mediaQueryUp.tablet} {
    margin-block-start: ${rem(24)};
  }
`

function SponsoredSearchTileModal() {
  const intl = useIntl()

  return <Modal isHeaderOverlay>
    <VerticalSpacer gap={16}>
      <LogoWrapper>
        <SponsoredTileLogo image={sponsoredSearchTileLogo} />
      </LogoWrapper>
      <Heading variant="heading3">
        {intl.formatMessage({
          id: 'Vo9LfEz-wuJ9t5iAy1xn',
          defaultMessage: 'Earn Triple Société Points with PayPal',
          description: 'Title of the modal shown when a customer taps Learn more on the PayPal Société Points sponsored search tile',
        })}
      </Heading>
      <BodyText variant="medium">
        {intl.formatMessage({
          id: 'Jh--bBm5BtjId7mi7PRW',
          defaultMessage: 'Check out securely with PayPal and unlock three times the Société Points. Plus, every booking goes into the draw to win 500,000 Société Points. Limited time only. T&Cs apply. Ends 31st August.',
          description: 'Main body copy of the modal shown when a customer taps Learn more on the PayPal Société Points sponsored search tile, explaining the triple points offer',
        })}
      </BodyText>
      <Caption variant="medium" colour="light-foreground-alt">
        {intl.formatMessage({
          id: 'F0lCAb43KlUOmZ0A9Hbk',
          defaultMessage: 'Terms & eligibility criteria apply. PayPal Credit Pty Ltd Australian Credit Licence 568848',
          description: 'Fine-print legal disclaimer below the main body copy of the PayPal Société Points sponsored tile modal',
        })}
      </Caption>
    </VerticalSpacer>
  </Modal>
}

export default SponsoredSearchTileModal
